<template>
  <div>
    <!-- 配货单已出货 -->
    <baseBreadcrumb
      :page="$t('message.shipped')"
      :menu="$t('message.porder')"
    />

    <porderBaseTable :status="60" />
  </div>
</template>
<script>
import porderBaseTable from "@/components/porder/porderBaseTable/index";
export default {
  components: { porderBaseTable },
  data() {
    return {};
  },
  methods: {},
};
</script>
<style lang='scss' scoped>
</style>